export default "__VITE_ASSET__9f1c19a2__$_?react__"